"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _ComponentData2 = _interopRequireDefault(require("./ComponentData"));

var _GradeTypeConstants = _interopRequireDefault(require("../../constants/GradeTypeConstants"));

var RadialData =
/*#__PURE__*/
function (_ComponentData) {
  (0, _inherits2.default)(RadialData, _ComponentData);

  function RadialData() {
    (0, _classCallCheck2.default)(this, RadialData);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RadialData).apply(this, arguments));
  }

  (0, _createClass2.default)(RadialData, [{
    key: "init",
    value: function init(grade) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(RadialData.prototype), "init", this).call(this, grade);
      this.setScore(grade);
    } // Override

  }, {
    key: "setScore",
    value: function setScore() {} // Override

  }, {
    key: "setDisplayValue",
    value: function setDisplayValue() {} // Helper

  }, {
    key: "getGoodOkBadGradeType",
    value: function getGoodOkBadGradeType(grade, goodThreshold, okThreshold) {
      if (grade < goodThreshold) {
        return _GradeTypeConstants.default.GOOD;
      } else if (grade < okThreshold) {
        return _GradeTypeConstants.default.OK;
      } else {
        return _GradeTypeConstants.default.BAD;
      }
    }
  }]);
  return RadialData;
}(_ComponentData2.default);

var _default = RadialData;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/data/components/RadialData.js
// module id = 101
// module chunks = 0